var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.modalId,"title":_vm.modalTitle,"size":_vm.modalSize}},[_vm._t("default",function(){return [_c('p',{staticClass:"my-4"},[_vm._v("Hello from modal!")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }